import { eventActions, interactionHistoryActions } from '../../actions';
import { interactionHistorySelectors } from '../../selectors';
import { segmentConfigSelectors } from '../../selectors';

export default store => next => action => {
  const result = next(action);
  const state = store.getState();

  switch (action.type) {
    case interactionHistoryActions.NAVIGATE_PAGE:

    case interactionHistoryActions.UPDATE_FIELD: {
      global.interactionHistory = interactionHistorySelectors.get(state);
      break;
    }

    case eventActions.PIGGYBANK_EVENT: {
      if (action.event.type === 'onChange') {
        const { lastField } = interactionHistorySelectors.getLastTrace(state);

        if (lastField !== action.event.name) {
          store.dispatch(
            interactionHistoryActions.updateField(
              segmentConfigSelectors.getCurrentSegmentName(state),
              segmentConfigSelectors.getCurrentPageName(state),
              action.event.name
            )
          );
        }
        break;
      }
    }

    default: {
      const { lastPage, lastSegment } =
        interactionHistorySelectors.getLastTrace(state);

      const currentSegmentName =
        segmentConfigSelectors.getCurrentSegmentName(state);

      const currentPageName = segmentConfigSelectors.getCurrentPageName(state);

      if (currentSegmentName !== lastSegment || currentPageName !== lastPage) {
        store.dispatch(
          interactionHistoryActions.navigatePage(
            currentSegmentName,
            currentPageName
          )
        );
      }
    }
  }

  return result;
};
